exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".delete-review[data-v-7ca206c8]{color:#00937f;background-color:transparent;border:none;outline:none}.delete-review[data-v-7ca206c8]:hover{color:#ff7546;outline:none}", ""]);

// exports
